import { Routes } from '@angular/router';
import {AuthGuard} from '../../appauth/auth/auth.guard';
import { RecepcionistaListaComponent } from './view-recepcionista/recepcionistavista.component';
export const RecepcionistasRoutes: Routes = [{
	path: '',
	redirectTo: 'recepcionista-lista',
	pathMatch: 'full',
	canActivate: [AuthGuard]
},{
	path: '',
	children: [{
		path: 'recepcionista-lista',
		component: RecepcionistaListaComponent,
		canActivate: [AuthGuard]
	}]
}];
